import React from 'react';
import Slider from "react-slick";
import { Col, Container, Row } from 'react-bootstrap';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Images from '../../Assets/Images/Images';
import './Testimony.scss';

const Testimony = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    arrows: false
  };

  return (
    <div
      className='testimony'
      style={{ backgroundImage: `url(${Images.testimony})` }}
    >
      <div className='overlay' />
      <Container>
        <Row>
          <Col>
            <h2>TESTIMONIAL</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Slider
              className='testimony__carousel'
              {...settings}
            >
              <div>
                <p className='testimony__text'>“Aku udah tinggal di sini dari awal kuliah sampe koas sekarang, menurut
                  aku di sini tuh enak banget, kemana-mana deket tinggal keluar gang ada richeese, ada pizza hut, mau
                  ngopi bisa ke starbucks atau kedai kopi lainnya yang bertebaran di sini, mau all you can eat tinggal
                  pilih juga..mau ke atm tinggal jalan kaki sekitar 500meter..mau ke kampus juga deket sekitar
                  700meter..yang paling penting disini tuh bersih, mba dan satpamnya stand by 24 jam jadi kalo ada apa2
                  nggak pusing carinya dan mereka juga ramah-ramah..untuk harganya affordable dengan fasilitas yang di
                  sediain</p>
                <p className='testimony__text'>Mantaap pokonya”</p>
                <p className='testimony__name'>Zia - Mahasiswi FKG Moestopo</p>
              </div>
              <div>
                <p className='testimony__text'>“Saya penghuni House of Arie kamar no 108, sudah hampir 5 tahun tinggal di
                  sini. Fasilitas kamar yang cukup memadai untuk anak kos ditambah free wifi. Tersedia fasilitas umum,
                  seperti dapur, ruang tamu, kulkas, tempat parkir motor/mobil. Khususnya bagi yang hobi masak, bisa
                  memanfaatkan fasilitas dapur dengan nyaman. Betah tinggal di sini karena kebersihan setiap area dan
                  privacy terjaga. Ada security yang jaga selama 24 jam, sehingga kalau mau bepergian dalam jangka waktu
                  yang lama pun tidak perlu merasa khawatir. Lokasi kos yang strategis menjadi pertimbangan saya memilih
                  House of Arie, dekat dengan pintu tol Veteran-Tanah Kusir. Mau cari makan pun mudah. Pengelola kos pun
                  cukup responsif jika ada keluhan dari anak kos.
                  Oo iya ada fasilitas kamar tamu juga untuk orang tua saat datang berkunjung.</p>
                <p className='testimony__text'>Sangat recommended bagi yang ingin ngekos di sini.”</p>
                <p className='testimony__name'>Shinta - Pegawai Swasta</p>
              </div>
              <div>
                <p className='testimony__text'>“homey, lahan parkir luas dan kamar nyaman sekali”</p>
                <p className='testimony__name'>Nindy - Pegawai Swasta</p>
              </div>
            </Slider>
          </Col>
        </Row>
      </Container>
    </div>
  )
};

export default Testimony;
